export enum UseInCommerceRequestNotification {
  souKickOff = 'sou-kick-off',
  // externalKickOff = 'external-kick-off',
  // partnerKickOff = 'partner-kick-off',
  souLandingPageNotVisited1Week = 'sou-reminder-not-clicked',
  souLandingPageNotVisited1MonthBeforeDeadline = 'sou-reminder-not-clicked-1M',
  souLandingPageNotVisited3MonthsBeforeDeadline = 'sou-reminder-not-clicked-3M',
  souLandingPageNotVisited1WeekBeforeDeadline = 'sou-reminder-not-clicked-1W',
  souDecisionExpected3MonthsBeforeDeadline = 'sou-reminder-not-submitted-3M',
  souDecisionExpected1MonthBeforeDeadline = 'sou-reminder-not-submitted-1M',
  souDecisionExpected1WeekBeforeDeadline = 'sou-reminder-not-submitted-1W',
  souCompleteOrder1Day = 'sou-reminder-not-paid',
  souCompleteOrder1MonthBeforeDeadline = 'sou-reminder-not-paid-1M',
  souCompleteOrder1WeekBeforeDeadline = 'sou-reminder-not-paid-7D',
  souVoluntaryAbandonment = 'sou-abandoned-by-user',
  souReviewCommentsFromLawyer = 'sou-draft-send-for-approval',
  souReviewCommentsFromLawyer2days = 'sou-draft-reminder-not-approved-2D',
  souReviewCommentsFromLawyer4days = 'sou-draft-reminder-not-approved-4D',
  souReviewCommentsFromLawyer6days = 'sou-draft-reminder-not-approved-6D',
  souSubmitted = 'sou-confirmation',
  souExtensionSubmitted = 'sou-confirmation-extension',
  souDivideSubmitted = 'sou-confirmation-divide',
  souAmendmentAfterNoaSubmitted = 'sou-confirmation-amendment',
  paid = 'sou-paid',
  souCommentsLeft = 'sou-draft-reminder-not-submitted',
  souAbandonmentConfirmed = 'sou-abandonment-confirmed',
  checkoutCompleted = 'sou-service-checkout-completed',
  useInCommerceRequestUrgingSms = 'sms-use-in-commerce-request-reminder',
  douKickOff = 'dou-kick-off',
  douVoluntaryAbandonment = 'dou-voluntary-abandonment',
  douDraftSendForApproval = 'dou-draft-send-for-approval',
  douDraftReminderNotApproved2D = 'dou-draft-reminder-not-approved-2D',
  douDraftReminderNotApproved4D = 'dou-draft-reminder-not-approved-4D',
  douDraftReminderNotApproved6D = 'dou-draft-reminder-not-approved-6D',
  douCommentsLeft = 'dou-draft-reminder-not-submitted',
  douConfirmation = 'dou-confirmation',
  douAbandonmentConfirmed = 'dou-abandonment-confirmed',
  douReminderNotClicked = 'dou-reminder-not-clicked',
  douReminderNotClicked6M = 'dou-reminder-not-clicked-6M',
  douReminderNotClicked1M = 'dou-reminder-not-clicked-1M',
  douReminderNotClicked1W = 'dou-reminder-not-clicked-1W',
  douReminderNotClicked1MGracePeriod = 'dou-reminder-not-clicked-1M-grace-period',
  douReminderNotSubmitted6M = 'dou-reminder-not-submitted-6M',
  douReminderNotSubmitted1M = 'dou-reminder-not-submitted-1M',
  douReminderNotSubmitted1W = 'dou-reminder-not-submitted-1W',
  douReminderNotSubmitted1MGracePeriod = 'dou-reminder-not-submitted-1M-grace-period',
  douReminderNotPaid = 'dou-reminder-not-paid',
  douReminderNotPaid1M = 'dou-reminder-not-paid-1M',
  douReminderNotPaid7D = 'dou-reminder-not-paid-7D',
  renewalKickOff = 'renewal-kick-off',
}
